<template>
  <div>
    <common-dialog
      ref="dialog"
      width="750px"
      show-save-button
      unit="货车资料"
      edit-title
      id-key="VehicleId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="车牌号码" prop="LicensePlate">
              <el-input
                v-model="data.LicensePlate"
                placeholder="请输入车牌号码"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="车主名称" prop="Owner">
              <el-input v-model="data.Owner" placeholder="请输入车主名称" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="车主电话" prop="Phone">
              <el-input v-model="data.Phone" placeholder="请输入车主电话" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12" v-if="iShow('IsOut')">
            <el-form-item label="是否外车">
              <el-select v-model="data.IsOut">
                <el-option label="否" :value="false"></el-option>
                <el-option label="是" :value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="司机电话" prop="DriverPhone">
              <el-input
                v-model="data.DriverPhone"
                placeholder="请输入司机电话"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12" v-if="iShow('Volume')">
            <el-form-item label="体积" prop="Volume">
              <el-input v-model="data.Volume" v-num placeholder="请输入体积" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12" v-if="iShow('Tonnage')">
            <el-form-item label="吨位" prop="Tonnage">
              <el-input v-model="data.Tonnage" v-num placeholder="请输入吨位" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="Sn">
              <el-input type="number" v-int v-model="data.Sn" style="width: 100px"></el-input>
              <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
              <span class="t-tips">*值越小排得越前</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12" v-if="iShow('Status')">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status" class="detail-span">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        VehicleId: 0,
        LicensePlate: "", //车牌
        Owner: "", //车主
        Phone: "", //电话
        IsOut: false, //是否外车
        DriverPhone: "", //司机电话
        Volume: "", //体积
        Tonnage: "", //吨位
        Status: 1,
        Sn:null,
      },
      isMB: this.$store.state.isMB,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/vehicle").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        LicensePlate: [{ required: true, message: "车牌不能为空" }],
        Owner: [{ required: true, message: "车主名称不能为空" }],
        Phone: [
          { required: true, message: "车主电话不能为空" },
          { validator: this.$commonJs.validateRules.validPhone2 },
        ],
        DriverPhone: [
          { required: true, message: "司机电话不能为空" },
          { validator: this.$commonJs.validateRules.validPhone2 },
        ],
        Sn: [{ required: true, message: "序号不能为空" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash ? this.urlHash.split("/").join(""): location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },

    onEditOpened(data) {},

    onClosed() {
      this.showList = [];
    },
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
  },
};
</script>